import { render } from "./InfoRowProm.vue?vue&type=template&id=909b3d80&scoped=true"
import script from "./InfoRowProm.vue?vue&type=script&lang=js"
export * from "./InfoRowProm.vue?vue&type=script&lang=js"

import "./InfoRowProm.vue?vue&type=style&index=0&id=909b3d80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909b3d80"]])

export default __exports__